/**
 * The scheduling fields of a DatoCMS banner promo (ISO `YYYY-MM-DD` dates).
 * Typed loosely because the CMS scalar types depend on the generated schema.
 */
type ScheduledPromo = {
	startDate?: unknown;
	endDate?: unknown;
};

/**
 * Keeps the banner promos running on the given day.
 * Banners without dates are always active; both bounds are inclusive.
 *
 * @param promos - Banner promos already filtered on `isActive` by the query.
 * @param today - The day to check, as `YYYY-MM-DD`. Defaults to today (UTC).
 * @returns The promos whose date range includes `today`, in their original order.
 */
export function filterActivePromos<T extends ScheduledPromo>(
	promos: T[],
	today: string = new Date().toISOString().slice(0, 10)
): T[] {
	return promos.filter((p) => {
		if (typeof p.startDate === 'string' && p.startDate > today) return false;
		if (typeof p.endDate === 'string' && p.endDate < today) return false;
		return true;
	});
}
